import { Users, MessageCircle, MapPin, Calendar, PartyPopper, Building2, LayoutGrid } from 'lucide-react';

/**
 * Module configuration with icons and colors
 */
const MODULE_CONFIG = {
    CONTACTS: {
        icon: Users,
        color: '#3b82f6', // blue-500
        bgColor: 'bg-blue-500'
    },
    MESSAGES: {
        icon: MessageCircle,
        color: '#8b5cf6', // purple-500
        bgColor: 'bg-purple-500'
    },
    MAP: {
        icon: MapPin,
        color: '#22c55e', // green-500
        bgColor: 'bg-green-500'
    },
    AGENDA: {
        icon: Calendar,
        color: '#f97316', // orange-500
        bgColor: 'bg-orange-500'
    },
    EVENTS: {
        icon: PartyPopper,
        color: '#ec4899', // pink-500
        bgColor: 'bg-pink-500'
    },
    PLACES: {
        icon: Building2,
        color: '#8b5cf6', // purple-500
        bgColor: 'bg-purple-500'
    },
    MODULES: {
        icon: LayoutGrid,
        color: '#8b5cf6', // purple-500
        bgColor: 'bg-purple-500'
    }
};

/**
 * PageHeader Component
 * Displays a consistent header with module icon and title across all pages
 *
 * @param {Object} props
 * @param {string} props.moduleCode - Module code (CONTACTS, MESSAGES, MAP, AGENDA, EVENTS, PLACES)
 * @param {string} props.title - Page title
 * @param {string} props.subtitle - Optional subtitle/description
 * @param {React.ReactNode} props.children - Optional additional content (buttons, etc.)
 * @param {React.ElementType} props.customIcon - Optional custom icon component (overrides moduleCode icon)
 * @param {string} props.customColor - Optional custom color (overrides moduleCode color)
 */
const PageHeader = ({
    moduleCode,
    title,
    subtitle,
    children,
    customIcon,
    customColor
}) => {
    const config = MODULE_CONFIG[moduleCode] || MODULE_CONFIG.MODULES;
    const Icon = customIcon || config.icon;
    const iconColor = customColor || config.color;

    return (
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
            <div>
                <h1 className="text-2xl font-bold text-gray-900 dark:text-white flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl bg-white shadow-md flex items-center justify-center border border-gray-100">
                        <Icon className="w-6 h-6" style={{ color: iconColor }} />
                    </div>
                    {title}
                </h1>
                {subtitle && (
                    <p className="text-gray-500 dark:text-gray-400 mt-1 ml-13">
                        {subtitle}
                    </p>
                )}
            </div>
            {children && (
                <div className="flex items-center gap-2">
                    {children}
                </div>
            )}
        </div>
    );
};

export default PageHeader;
